import { Button } from '@mantine/core'
import MapControlBox from './MapControlBox'
import { TbNavigationSearch } from 'react-icons/tb'

const RefreshDirectionsToNextRouteButton = ({ onRefresh }: { onRefresh: () => void }) => {
  return (
    <MapControlBox position="top-left">
      <Button
        color="gray"
        variant="filled"
        onClick={e => {
          e.stopPropagation()
          onRefresh()
        }}
        styles={{
          root: {
            height: 60,
            borderRadius: 64,
            padding: '0 10px',
            fontSize: 40,
          },
        }}
      >
        <TbNavigationSearch />
      </Button>
    </MapControlBox>
  )
}

export default RefreshDirectionsToNextRouteButton
